import React, { Component } from "react";
import { Configurations } from '../../Utils/Configurations';
import axios from 'axios';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import moment from 'moment';
import Geral from "../../Utils/Geral";
import IdProducts from "../../Components/IdProducts/IdProducts";


class LocationInfoClients extends Component {

    constructor(props) {
        super(props);

        this.Configurations = new Configurations();


        this.filterSearch = this.filterSearch.bind(this);
        this.handleProductChange = this.handleProductChange.bind(this);
        this.handleEditionChange = this.handleEditionChange.bind(this);
        this.toggleFilters = this.toggleFilters.bind(this);
        this.addToFilter = this.addToFilter.bind(this);
        this.renderArrayFilter = this.renderArrayFilter.bind(this);
        this.getClients = this.getClients.bind(this);
        this.createFile = this.createFile.bind(this);
        this.removeItemFilter = this.removeItemFilter.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);



        this.state = {
            products: [],
            productEditions: [],
            isLoadingProducts: true,
            infosClients: {},
            arrayFilter: [],
            openFilters: true,
            hasError: false,
            errorMessage: '',
        };

        this.getProducts();

    }

    async getProducts() {
        this.setState({ isLoadingProducts: true })
        const _productsList = axios.get(this.Configurations.apiBasePath + `/logistica/produtos`);

        _productsList.then(response => {
            this.setState({
                products: response.data.produtos
            });
        }).catch(this.handleError).finally(() => this.setState({ isLoadingProducts: false }))
    }

    handleProductChange(e) {
        const _value = parseInt(e.target.value);
        const _product = this.state.products.find(item => item.idProduto === _value)
        let _editions = [];

        if (_product && _product.edicoes) _editions = _product.edicoes;

        const _toUpdate = {
            selectedProduct: _value,
            productEditions: _editions
        }

        this.setState(_toUpdate);
    }

    handleEditionChange(e) {
        const _toUpdate = {
            selectedEdition: parseInt(e.target.value)
        };

        this.setState(_toUpdate);
    }

    filterSearch(e) {
        e.preventDefault();
        this.getClients()
    }

    getClients(flag) {
        const { idLocal } = this.props.match.params;
        this.setState({ isLoadingClients: true })
        const _body = {
            edicoes: this.state.arrayFilter.map(item => {
                return { idProduto: item.selectedProduct, numEdicao: item.selectedEdition }
            })
        }
        const _clientsList = axios.post(this.Configurations.apiBasePath + `/logistica/local-entrega/${idLocal}/assinantes`, _body);
        _clientsList.then(response => {
            this.setState({ infosClients: response.data, flagBuscaRealizada: flag })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingClients: false }))
    }

    toggleFilters() {
        this.setState({
            openFilters: !this.state.openFilters
        })
    }

    addToFilter(e) {
        e.preventDefault();
        let arrFilter = this.state.arrayFilter;
        const { selectedProduct, selectedEdition } = this.state;
        const duplicate = this.state.arrayFilter.findIndex(item => item.selectedProduct === selectedProduct && item.selectedEdition === selectedEdition);
        if (duplicate < 0) arrFilter.push({ selectedProduct, selectedEdition })
        this.setState({ arrayFilter: arrFilter })
    }

    createFile(e) {
        const { idLocal } = this.props.match.params;
        this.setState({ isLoadingFile: true })
        const _body = {
            edicoes: this.state.arrayFilter.map(item => {
                return { idProduto: item.selectedProduct, numEdicao: item.selectedEdition }
            })
        }

        const _createFile = axios.post(this.Configurations.apiBasePath + `/logistica/local-entrega/${idLocal}/pdf/assinantes/gerar-arquivo`, _body);
        _createFile.then(response => {
            if (!!response.data.assinantes) {
                this.setState({ sucessoGeracaoPDF: true });
                Geral.downloadPDF(response.data.assinantes, `assinantes`)
            }
        }).catch(this.handleError)
            .finally(() =>
                this.setState({ isLoadingFile: false })
            )
    }

    removeItemFilter(i) {
        let _arrFilt = this.state.arrayFilter;
        _arrFilt.splice(i, 1)
        this.setState({ arrayFilter: _arrFilt })
    }

    renderArrayFilter() {
        if (this.state.arrayFilter.length <= 0) return <div></div>

        return this.state.arrayFilter.map((item, index) => {
            const _product = this.state.products.find(p => p.idProduto === item.selectedProduct)
            const _edition = _product.edicoes.find(e => e.numeroEdicao === item.selectedEdition)
            return <div className="col-2" key={index}>
                <div className="card">
                    <div className="card-body pt-0 pb-2">
                        <div className="row">
                            <div className="offset-6 col-6 text-right p-0 col-badge-x">
                                <span onClick={() => this.removeItemFilter(index)} className="badge badge-x text-white bg-danger">x</span>
                            </div>
                            <div className="col-12">
                                <p className="m-0 h3"><span className={`badge badge-${Geral.obtemTipoBadge(_product.sigla).badgeColor}`}>{_product.siglaProtheus}</span></p>
                                <p className="m-0"><small>ID ({_product.idProduto})</small></p>
                                <p className="m-0 pt-2 font-weight-bold">{_edition.numeroEdicao}</p>
                                <p className="m-0"><small>{moment(_edition.dtEntrega).format("DD/MM/YYYY")}</small></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        })
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.msg || err.response.data.message : !!err.message ? err.message : 'Erro inesperado.' })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    render() {
        return (

            <div className="row location-info-clients logistics">
                <div className="col-12">
                    <div className="row">
                        <div className="col-10">
                            <h2>Nome do local: {this.state.infosClients.nomeLocalEntrega} - Assinantes</h2>
                        </div>
                        <div className="col-2  text-right">
                            <button className="btn btn-outline-secondary" onClick={() =>
                                window.history.go(-1)}> voltar</button>
                        </div>
                    </div>
                </div>
                <div className="col-12 py-2">
                    <div className="card">
                        <div className="card-header p-2" id="headingOne">
                            <div className="col-12">
                                <button className="btn btn-link w-100 text-left" type="button" onClick={this.toggleFilters}>
                                    <i className={`fa mr-2 ${this.state.openFilters ? "fa-chevron-right" : "fa-chevron-down"}`}></i>
                                    Filtros
                                </button>
                            </div>
                        </div>
                        <div className={`card-body ${!this.state.openFilters && "collapse"}`} id="boxFilters">
                            {this.state.loading ? (
                                <div className="row no-gutters">
                                    <div className="col-12 text-center py-5">
                                        <div className="spinner-border text-primary" role="status" />
                                    </div>
                                </div>
                            ) : (
                                <form onSubmit={this.filterSearch} noValidate>
                                    <div className="row align-items-end">
                                        <div className="col-3">
                                            <IdProducts
                                                handleProductChange={this.handleProductChange}
                                                produtos={this.state.products}
                                                selectedProduct={this.state.selectedProduct}
                                            />
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group m-0">
                                                <label htmlFor="ddlEdicao">Edição</label>
                                                <select id="ddlEdicao" name="selectedEdition" className="form-control" disabled={this.state.productEditions.length === 0} onChange={this.handleEditionChange} value={this.state.selectedEdition || ''} >
                                                    <option value=""></option>
                                                    {this.state.productEditions.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.numeroEdicao}>{`${item.numeroEdicao} - ${moment(item.dtEntrega).format('DD/MM/YYYY')}`}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-3 text-center">
                                            <button onClick={this.addToFilter} disabled={!this.state.selectedEdition || !this.state.selectedProduct} className="btn btn-info">+ Adicionar ao filtro</button>
                                        </div>
                                        <div className="col-12 border my-4">
                                        </div>
                                        <div className="col-12 text-center">
                                            <div className="row">
                                                {this.renderArrayFilter()}
                                            </div>
                                        </div>
                                        <div className="col-12 text-right">
                                            {this.state.isLoadingClients ? (
                                                <div className="spinner-border text-primary" role="status" />
                                            ) : (
                                                <button className="btn btn-primary" disabled={this.state.arrayFilter.length <= 0} onClick={() => this.getClients(true)}>Buscar</button>
                                            )}
                                        </div>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>

                {(!!this.state.infosClients.listaAssinantes && this.state.infosClients.listaAssinantes.length > 0) && (
                    < div className="col-12 py-3">
                        <div className="card">
                            <div className="card-header text-center">Lista de assinantes</div>
                            <div className="card-body">
                                <div className="row">
                                    {this.state.isLoadingClients ? (
                                        <div className="col-12 text-center">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    ) : (
                                        <React.Fragment>
                                            <div className="col-12">
                                                <table className="w-100 table striped">
                                                    <thead>
                                                        <th width="5%">#</th>
                                                        <th width="40%">Nome (cód. membro)</th>
                                                        <th width="20%">Produtos</th>
                                                        <th width="35%">Bloco</th>
                                                    </thead>
                                                    <tbody>
                                                        {!!this.state.infosClients.listaAssinantes && this.state.infosClients.listaAssinantes.map((client, index) => {
                                                            return <tr className="pt-1" key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{client.nome} ({client.codMembro})</td>
                                                                <td>{client.produtos.map((prod, i) => {
                                                                    return <span key={i} className={`mx-1 badge badge-${Geral.obtemTipoBadge(prod.sigla).badgeColor}`}>{prod.qtd} {prod.siglaProtheus} {prod.edicao}</span>
                                                                })}</td>
                                                                <td>{client.bloco}</td>
                                                            </tr>
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="col-12 text-right">
                                                {this.state.isLoadingFile ? (
                                                    <div className="spinner-border text-primary" role="status" />
                                                ) : (
                                                    <button onClick={this.createFile} className="btn btn-info">gerar arquivo</button>
                                                )}
                                            </div>
                                        </React.Fragment>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )
                }
                {(this.state.flagBuscaRealizada && (!this.state.infosClients.listaAssinantes || this.state.infosClients.listaAssinantes.length <= 0)) && (
                    <div className="col-12 text-center py-2">
                        <p className="m-0"><strong>Nenhum assinante encontrado</strong></p>
                    </div>
                )}

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                    goBack={!this.state.hasError}
                />
            </div >
        )
    }
}

export default LocationInfoClients;